import React from 'react';
import { Box, Flex, Button } from '@chakra-ui/react';
import Heading from '#coreComponents/Heading';
import homeBackgroundImage from '../images/homepage-header-background.jpg';

const HomeHeader: React.FC = () => (
  <Flex
    p={6}
    color="white"
    backgroundImage={`url('${homeBackgroundImage}')`}
    backgroundSize="cover"
    backgroundRepeat="no-repeat"
    width="100%"
    height="400px"
    flexDir="column"
  >
    <Heading as="h1" fontSize={['3xl', '5xl', '6xl']}>
      Global data.
      <br />
      World universities.
      <br />
      International insights.
    </Heading>
    <Flex
      fontSize={['xl', '2xl']}
      flexGrow={1}
      flexDirection="column"
      justifyContent="center"
    >
      Helping universities through performance analysis & benchmarking.
    </Flex>
    <Box>
      <Button
        colorScheme="yellow"
        as="a"
        href="https://www.timeshighereducation.com/our-solutions/enquire-now"
      >
        Speak to an expert
      </Button>
    </Box>
  </Flex>
);

export default HomeHeader;
